import Client from './client';

export default class BillingStatementPendingReviews extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  getPending(options = {}) {
    return this.makeRequest(`${this.host}/internal/account/statement/reviews/pending`, options);
  }

}
